// TriangleRectangle.js
import React from 'react';
import { Row, Col } from 'antd';

const XAxisArrow = () => {
  const triangleStyle = {
    width: 0,
    height: 0,
    borderLeft: '20px solid transparent',
    borderRight: '20px solid transparent',
    borderBottom: '40px solid black',
    transform: 'rotate(90deg)',
  };

  const rectangleStyle = {
    width: '400px',
    height: '40px',
    backgroundColor: 'black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '5px'
  };

  const rotatedTextStyle = {
    color: 'white',
    fontWeight: 'bold',
  };

  return (
    <Row >
      <Col>
        <div style={rectangleStyle}>
          <span style={rotatedTextStyle}>Performance</span>
        </div>
      </Col>
      <Col>
        <div style={triangleStyle}></div>
      </Col>

    </Row>

  );
};

export default XAxisArrow;
